import { HttpClient } from "@angular/common/http";
import { inject, Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { Empresa, ResponseApiModel } from "../interfaces";
import { environment } from "@environments/environment";

@Injectable({
    providedIn: 'root',
})
export class PerfilService {
    private readonly _httpClient = inject(HttpClient)

    obtenerEmpresas(): Observable<ResponseApiModel<Array<Empresa>>> {
        return this._httpClient.get<ResponseApiModel<Array<Empresa>>>(`${environment.baseURL}perfil/empresas`);
    }
}